import { DeveloperContainer } from './DeveloperContainer';

const name = 'DeveloperContainer';

export { DeveloperContainer, name };
